import { useEffect, useState } from "react"
import Iconfont from '@utils/Iconfont';
import styles from './index.module.scss'
import { Divider } from "antd";
import eventBus from '@utils/eventBus';

export default function LabelToolBox (props) {
    const [mode, setMode] = useState() // rect/ellipse/brush/arrow/text

    useEffect(() => {
        props.onChange(mode)
    }, [mode])
    const handleModeChange = (value) => {
        setMode(pre => {
            if (pre != value) return value
            else return null
        })
    }

    return (
        <div className={styles.ModeRatio}>
            <div className={styles.LeftBox}>
                <Iconfont className={styles.Undo} type="icon-undo" onClick={props.onUndo} />
                <Iconfont className={styles.Reset} type="icon-refresh" onClick={props.onReset} />
            </div>
            <Divider
                type="vertical"
                style={{
                    borderColor:"rgba(34, 55, 244, 0.3)",
                    height:"1.5em",
                    marginInline: "1.5em"
                }}
            />
            <div className={styles.ToolBox}>
                <div className={`${mode=="rect" && styles.actived}`} type="icon-kuangxuan" onClick={() => handleModeChange("rect")}></div>
                <div className={`${mode=="ellipse" && styles.actived}`} type="icon-quanxuan" onClick={() => handleModeChange("ellipse")}></div>
                <div className={`${mode=="brush" && styles.actived}`} type="icon-huabi" onClick={() => handleModeChange("brush")}></div>
                <div className={`${mode=="arrow" && styles.actived}`} type="icon-arrow-right" onClick={() => handleModeChange("arrow")}></div>
                <div className={`${mode=="text" && styles.actived}`} type="icon-text" onClick={() => handleModeChange("text")}></div>
            </div>
        </div>
    )
}